import { axiosClient } from "../config/axios.config";
import { toast } from 'react-toastify';
import { catchBlock } from "./catchBlock";

export function deleteItem(url,id, items, setFn, successMsg) {
  axiosClient.delete(url+id).then(() =>{
    toast.success(successMsg + ' Deleted successfully')
    setFn(items.filter((el) => el._id !== id ))
  } ).catch(catchBlock);
}